import type { App } from '../app/App';
import {
  UnlockBlockerPopup,
  type UnlockBlockerPopupConfig,
} from '../game/views/popups/UnlockBlockerPopup';

export async function openUnlockBlockerPopup(
  app: App,
  config: UnlockBlockerPopupConfig,
): Promise<boolean> {
  const {
    controller: { popups },
  } = app;

  const { resolve, promise } = Promise.withResolvers<boolean>();

  // check if popup is already open
  if (popups.hasActivePopup(UnlockBlockerPopup)) {
    resolve(false);
    return promise;
  }

  const popup = new UnlockBlockerPopup(config);

  popup.onResult.connect(async (unlock: boolean) => {
    await popup.animateHide();
    await popups.closeActivePopup();
    resolve(unlock);
  });

  void popups.addPopup({
    popupInstance: popup,
    settings: { hideRays: true, overlay: false, overlayFillOpacity: 0 },
  });

  return promise;
}